import { Floor } from '../../interfaces/api/floor';
import {
	FloorSearchFilterParam,
	getFloor,
	getFloors,
	getFloorsSearchFilter,
} from '../../api/floors';

export async function fetchFloors(): Promise<Floor[]> {
	try {
		return await getFloors();
	} catch (error) {
		throw error;
	}
}

export async function fetchFloor(id: number): Promise<Floor> {
	try {
		return await getFloor(id);
	} catch (error) {
		throw error;
	}
}

export async function fetchFloorsSearchFilter(params: FloorSearchFilterParam): Promise<Floor[]> {
	try {
		return await getFloorsSearchFilter(params);
	} catch (error) {
		throw error;
	}
}
